// extracted by mini-css-extract-plugin
export default {"base":"vp_UasyD","divideNone":"vp_zsy3D","divideTiny":"vp_Snrwq","divideSmall":"vp_eghS6","divideMedium":"vp_DPTjc","divideLarge":"vp_vtHtW","alignCenter":"vp_x6bPS"};